var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fieldset", { staticClass: "ui-option-fields-fieldset" }, [
    _c("legend", [_vm._v(_vm._s(_vm.label))]),
    _vm._v(" "),
    _c("div", { staticClass: "field-description" }, [
      _vm.required
        ? _c("div", [
            _vm._v(
              "\n      " + _vm._s(_vm.t("app-radios-required-tip")) + "\n      "
            ),
            _c("span", { staticClass: "ui-field-required-marker" }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.description ? _c("div", [_vm._v(_vm._s(_vm.description))]) : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ui-option-fields-wrapper",
        attrs: { "data-cols": _vm.cols },
      },
      _vm._l(_vm.options, function (option, i) {
        return _c(
          "div",
          { staticClass: "ui-radio-field ui-field ui-option-field" },
          [
            _c("div", { staticClass: "ui-option-field-wrapper" }, [
              _c("input", {
                attrs: {
                  type: "radio",
                  id: `${_vm.id}-${option.name}`,
                  name: _vm.name,
                  required: _vm.required,
                },
                domProps: {
                  checked: _vm.aValue === option.value,
                  value: option.value,
                },
                on: { input: _vm.onInput },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "ui-radio-state-indicator ui-option-state-indicator",
              }),
              _vm._v(" "),
              _c("div", {
                staticClass:
                  "ui-radio-secondary-indicator ui-option-secondary-indicator",
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-option-label" }, [
              _c("label", { attrs: { for: `${_vm.id}-${option.name}` } }, [
                _vm._v(_vm._s(option.name)),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }